import { useOutletContext } from "react-router-dom";
import NoticeList from "../components/NoticeList";
import InfoTip from "../components/InfoTip";

const TIPS = {
  active:
    "Current portal notices for your organization (maintenance, product updates, and other announcements).",
  pending:
    "Scheduled or upcoming notices that are not active yet. They appear here before they go live.",
};

export default function Notifications() {
  const { notices = [] } = useOutletContext() || {};
  const active = notices.filter((n) => n.section === "active");
  const pending = notices.filter((n) => n.section === "pending");

  return (
    <div>
      <h1 style={{ marginTop: 0, fontSize: 22 }}>Notifications</h1>
      <section style={{ marginBottom: 24 }}>
        <h2
          style={{
            fontSize: 16,
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          Active
          <InfoTip text={TIPS.active} />
        </h2>
        <NoticeList items={active} emptyText="No notices." />
      </section>
      <section>
        <h2
          style={{
            fontSize: 16,
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          Upcoming / pending
          <InfoTip text={TIPS.pending} />
        </h2>
        <NoticeList items={pending} emptyText="No upcoming notices." />
      </section>
    </div>
  );
}
